import React from 'react';
import {Link} from 'react-router-dom'

function LogoImage(props) {

    return (
        <Link to={`${process.env.PUBLIC_URL}/`} >
            <img src={`${process.env.PUBLIC_URL}/assets/images/icon/logo/small-bubble-logo.png`} alt="" className="img-fluid" />
            <br /><h5 style={{fontFamily: "serif"}}>Practical advice for making an impression.</h5>
        </Link>
    )
}

export default LogoImage;
